module.exports = __webpack_public_path__ + "static/img/no_link.3034fa52.png";